import categoryService from '../../services/category.service';

export default {
    namespaced: true,
    state: {
        categoryList: [],
    },
    getters: {
        getCategoryListOptions: (state) => {
            return state.categoryList.map((category) => {
                return {
                    value: category.id,
                    label: category.name,
                };
            });
        },
    },
    mutations: {
        setCategoryList(state, category) {
            state.categoryList = category;
        },
    },
    actions: {
        GET_ALL_CATEGORY({ commit }, { name }) {
            categoryService.getCategoryList(
                {
                    params: {
                        name,
                    },
                },
                {
                    success: ({ data }) => {
                        commit('setCategoryList', data.data);
                    },
                    error: (error) => {
                        console.log(error);
                        console.clear();
                        // errorCallback(error);
                    },
                }
            );
        },
        CREATE_NEW_CATEGORY(context, { payload, successCallback, errorCallback }) {
            categoryService.createCategory(
                { name: payload },
                {
                    success: (res) => {
                        successCallback && successCallback(res);
                    },
                    error: (error) => {
                        successCallback && errorCallback(error);
                    },
                }
            );
        },
    },
};
